import firebase, { QuerySnapshot } from "store/firebase";
import "firebase/firestore";

import { eventFromDoc } from "./utils";
import { AnyAction, Dispatch } from "redux";
import { TastingEvent } from "./reducer";
import { createSubscriptionRegistry } from "store/util/subscription-registry";

export const EVENT_REMOVED_EVENT = "event-removed";
export const EVENT_MODIFIED_EVENT = "event-modified";
export const ACTION_EVENTS_LISTEN_CHANGE = "events/listen_change";
export const ACTION_EVENTS_LISTEN_REMOVE = "events/listen_remove";

/**
 * Per-user Firestore subscription registry. Resubscribing for the same user
 * replaces the previous listener; subscribing for a different user (e.g. the
 * tester opens a second tab while logged in elsewhere) doesn't stomp the
 * existing listener. Replaces the singleton `let _unsubscribe` that the
 * legacy implementation used.
 */
const subscriptions = createSubscriptionRegistry();

export function subscribe(userEmail: string) {
  if (!userEmail) return;
  subscriptions.subscribe(userEmail, () => {
    const relatedEventsCollectionRef = firebase
      .firestore()
      .collection("events")
      .where("related", "array-contains", userEmail);
    return relatedEventsCollectionRef.onSnapshot(
      (snapshot: QuerySnapshot) => {
        snapshot.docChanges().forEach((change) => {
          const eventData = eventFromDoc(change.doc);
          let windowEvent;
          switch (change.type) {
            case "added":
            case "modified": {
              windowEvent = new CustomEvent(EVENT_MODIFIED_EVENT, {
                detail: eventData,
              });
              break;
            }
            case "removed": {
              windowEvent = new CustomEvent(EVENT_REMOVED_EVENT, {
                detail: change.doc.id,
              });
              break;
            }
          }
          if (windowEvent) {
            window.dispatchEvent(windowEvent);
          }
        });
      },
      (error: any) => {
        console.log(error);
      }
    );
  });
}

export function unsubscribe(userEmail?: string) {
  if (userEmail) {
    subscriptions.unsubscribe(userEmail);
  } else {
    subscriptions.unsubscribeAll();
  }
}

export function listenChange(event: TastingEvent) {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch({ type: ACTION_EVENTS_LISTEN_CHANGE, payload: event });
  };
}

export function listenRemove(eventId: string) {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch({ type: ACTION_EVENTS_LISTEN_REMOVE, payload: eventId });
  };
}
